'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useAskInputActions, useAskInputState, } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { useAskInputModelSelectorAnalytics } from '#pplx/frontend/apps/ask/ask-input/model-selector/useAskInputModelSelectorAnalytics.js';
import { ASK_INPUT_MENU } from '#pplx/frontend/apps/ask/types/askInputMenu.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useCallback, useEffect } from 'react';
const LazySearchModelMenu = Dynamic(async () => {
    const { SearchModelMenu } = await import('#pplx/frontend/apps/ask/search-models-menu/adapter/SearchModelMenu.js');
    return { default: SearchModelMenu };
});
/**
 * Renders a controlled search-model menu within an Ask input menu context.
 *
 * The component requires an `AskInputProvider`. Menu visibility is coordinated
 * with the provider's active menu, and selection analytics are enabled only when
 * `trackModelSelection` is true.
 */
export function AskInputModelSelector({ querySource, searchMode, trackModelSelection, disabled = false, ...searchModelMenuProps }) {
    const { activeMenu } = useAskInputState();
    const { closeActiveMenuIfCurrent, onActiveMenuChange } = useAskInputActions();
    const { trackModelSelectorOpened, trackModelSelectionAttempt } = useAskInputModelSelectorAnalytics({
        querySource,
        searchModelProps: searchModelMenuProps,
        selectedSearchMode: searchMode,
        enabled: trackModelSelection && !disabled,
    });
    const closeMenu = useCallback(() => closeActiveMenuIfCurrent(ASK_INPUT_MENU.SEARCH_MODEL_MENU), [closeActiveMenuIfCurrent]);
    useEffect(() => {
        if (disabled)
            closeMenu();
    }, [closeMenu, disabled]);
    const handleToggle = useCallback((isOpen) => {
        if (isOpen) {
            trackModelSelectorOpened();
            onActiveMenuChange(ASK_INPUT_MENU.SEARCH_MODEL_MENU);
            return;
        }
        closeMenu();
    }, [closeMenu, onActiveMenuChange, trackModelSelectorOpened]);
    return (_jsx(LazySearchModelMenu, { ...searchModelMenuProps, disabled: disabled, isOpen: activeMenu === ASK_INPUT_MENU.SEARCH_MODEL_MENU, onToggle: handleToggle, onModelSelectionAttempt: trackModelSelectionAttempt, searchMode: searchMode }));
}
//# sourceMappingURL=AskInputModelSelector.js.map